import { PendingUsersItem } from "./PendingUsersItem";

export default PendingUsersItem;
